import React from 'react';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import { KNOWLEDGE_HUB_FREE } from 'app/components/Drawer/data';
import { FilledButton } from 'app/components/Buttons/FilledButton';
import {
  aidButtonsCss,
  aidProfessionalCss,
} from 'app/modules/web-shop/sub-modules/landing-module/components/aid-professionals-block/style';
import { ReactComponent as AidProfessionlImg } from 'app/modules/web-shop/sub-modules/landing-module/components/aid-professionals-block/assets/AidProfessionals.svg';

export function AidProfessional() {
  const buttons = (
    <React.Fragment>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={`${KNOWLEDGE_HUB_FREE}#h.wvet9pcoupx7`}
      >
        <FilledButton label="Quick start as a Project Manager" />
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={`${KNOWLEDGE_HUB_FREE}#h.defhv4kkhuh7`}
      >
        <FilledButton label="Quick start as a Fundraiser" />
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={`${KNOWLEDGE_HUB_FREE}#h.3noe4as98jle`}
      >
        <FilledButton label="Quick start as a PMEL Officer" />
      </a>
    </React.Fragment>
  );

  return (
    <div
      css={`
        background-color: #f7f7f7;

        @media (max-width: 962px) {
          background-color: #fff;
        }
      `}
    >
      <Container maxWidth="lg" css={aidProfessionalCss}>
        <Grid container spacing={6} alignItems="center">
          <Grid
            item
            xs={12}
            md={7}
            lg={6}
            css={`
              margin-top: 2rem;
              @media (max-width: 962px) {
                order: 2;
              }
            `}
          >
            <AidProfessionlImg />
          </Grid>
          <Grid
            item
            xs={12}
            md={5}
            lg={6}
            css={`
              @media (max-width: 962px) {
                order: 1;
              }
            `}
          >
            <h2>For Aid Professionals</h2>
            <p>
              AIDA is the ideal data service that can aid you in <br />{' '}
              accomplishing your objectives, regardless of your role as
              <br /> a fundraiser, project officer, program manager, or grant{' '}
              <br /> manager. AIDA offers a comprehensive overview of the{' '}
              individuals working on specific projects and their location.{' '}
              <br /> With the data available on AIDA, you can enhance your
              <br />
              reports, gain valuable insights, and make informed <br />{' '}
              decisions on how to be more efficient. Utilizing the data on{' '}
              <br />
              this platform is effortless, as you can quickly find, <br />{' '}
              visualize, and utilize the information without having to <br />{' '}
              engage in extensive data collection and analysis.
            </p>
            <div
              css={`
                ${aidButtonsCss}

                @media (max-width: 962px) {
                  display: none;
                }
              `}
            >
              {buttons}
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            lg={6}
            css={`
              order: 3;

              @media (min-width: 963px) {
                display: none;
              }
            `}
          >
            <div css={aidButtonsCss}>{buttons}</div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
